(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !window.DesignMode) return;
  try {
    

	var countDownDate = new Date("Jul 1, 2024 23:58:00").getTime();

	var x = setInterval(function() 
	{
   
      var now = new Date().getTime();

      var distance = countDownDate - now;    

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      document.getElementById("daysSpan").innerHTML = ("0" + days).slice(-2);
      document.getElementById("hoursSpan").innerHTML = ("0" + hours).slice(-2);
      document.getElementById("minutesSpan").innerHTML = ("0" + minutes).slice(-2);
	  document.getElementById("secondsSpan").innerHTML = ("0" + seconds).slice(-2);
   
 	}, 1000); 


  } catch(e) { console.error(e); }
})();
})();
